export default __webpack_public_path__ + "static/media/allinfra2.83d1725b.png";